/**
 * Appends an extension suffix to an already-formatted phone number for display.
 * Returns the number unchanged when there is no extension.
 */
export const formatDestination = (formattedNumber: string, extension?: string | null): string =>
    extension ? `${formattedNumber} ext. ${extension}` : formattedNumber;
